import { accommodationQuantityTypeZodEnum } from "@@/shared/acquire/accommodation-quantity-types";
import { bookableOptionIdZodSchema } from "@@/shared/acquire/resource-reference-options/bookable-option-id";
import { z } from "zod";

const productFormFieldItemsInCartQuantityZodLiteral =
    z.literal("ITEMS_IN_CART");

const productFormFieldGroupableQuantityZodUnion = z.union([
    bookableOptionIdZodSchema,
    accommodationQuantityTypeZodEnum,
    productFormFieldItemsInCartQuantityZodLiteral,
]);
type ProductFormFieldGroupableQuantity = z.infer<
    typeof productFormFieldGroupableQuantityZodUnion
>;

const productFormFieldGroupByZodUnion = z.union([
    productFormFieldGroupableQuantityZodUnion,
    z.literal("NO_GROUP"),
]);

type ProductFormFieldGroupBy = z.infer<typeof productFormFieldGroupByZodUnion>;

const productFormFieldQuantityZodUnion = z.union([
    productFormFieldGroupableQuantityZodUnion,
    z.number().int().positive().min(1),
]);
type ProductFormFieldQuantity = z.infer<
    typeof productFormFieldQuantityZodUnion
>;

export {
    productFormFieldGroupableQuantityZodUnion,
    productFormFieldGroupByZodUnion,
    productFormFieldItemsInCartQuantityZodLiteral,
    productFormFieldQuantityZodUnion,
};
export type {
    ProductFormFieldGroupableQuantity,
    ProductFormFieldGroupBy,
    ProductFormFieldQuantity,
};
